import PrintButton from "@/app/shared/print-button";
import routes from "@/routers/routes";
import { fetchOrders } from "@/server/api-services";
import { Order, OrderStatus } from "@/types";
import { useState, useEffect } from "react";
import PageHeader from "@/app/shared/page-header";
import OrderReport from "@/app/shared/orders/reports/OrderReport";

const pageHeader = {
    title: "Order Report",
    breadcrumb: [
        {
            href: routes.eCommerce.dashboard,
            name: "Home",
        },
        {
            href: routes.billing.home,
            name: "Orders",
        },
        {
            name: "Report",
        },
    ],
};

export default function OrderReportPage() {
    const [orders, setOrders] = useState([] as Order[]);

    useEffect(() => {
        getOrders();
    }, []);

    async function getOrders() {
        const response = await fetchOrders();

        if (response.statusCode !== 200) {
            return;
        }

        var data = response.data as Order[];

        data = data.map((order) => ({
            ...order,
            status: OrderStatus[order.status as keyof typeof OrderStatus],
        }));

        setOrders(data);
    }

    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            >
                <div className="mt-4 flex items-center gap-3 @lg:mt-0">
                    <PrintButton />
                    {/* <Button className="w-full @lg:w-auto">
                        <PiDownloadSimpleBold className="me-1.5 h-[17px] w-[17px]" />
                        Download
                    </Button> */}
                </div>
            </PageHeader>

            <OrderReport Orders={orders} />
        </>
    );
}
